import { render, staticRenderFns } from "./TaskComments.vue?vue&type=template&id=029f7d9e&"
import script from "./TaskComments.vue?vue&type=script&lang=ts&"
export * from "./TaskComments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports